import { render, staticRenderFns } from "./ServiceGroupEdit.vue?vue&type=template&id=3d9681d4&scoped=true&"
import script from "./ServiceGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroupEdit.vue?vue&type=style&index=0&id=3d9681d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9681d4",
  null
  
)

export default component.exports